// import React from "react";
// import { Router } from "@reach/router";

// import Routes from "./index";
// import AppComponent from "./AppComponent";

// function RouteComponent(props) {
//   const { location } = props;
//   const RouteList = Routes.map((route, index) => {
//     let routeComponent = null;

//     if (typeof route.children !== "undefined") {
//       const childrens = route.children;
//       const childrenComponent = childrens.map((route, index) => (
//         <AppComponent
//           key={index}
//           path={route.path}
//           component={route.component}
//         />
//       ));

//       routeComponent = (
//         <AppComponent
//           path={route.path}
//           key={index}
//           component={route.component}
//         >
//           {childrenComponent}
//         </AppComponent>
//       );
//     } else {
//       routeComponent = (
//         <AppComponent
//           key={index}
//           path={route.path}
//           component={route.component}
//         />
//       );
//     }
//     return routeComponent;
//   });

//   return (
//     <>
//       <Router location={location}>
//         {RouteList}
//         {/*<NotFound default />*/}
//       </Router>
//     </>
//   );
// }

// export default RouteComponent;


import React from "react";
import { Router } from "@reach/router";
import Routes from "./index";
import AppComponent from "./AppComponent";
import { extractOperatorName } from "constants/config";

function RouteComponent({ location }) {
  const operator = extractOperatorName(location.href || window.location.href, "after");
  const basePath = `/${operator}`;

  const RouteList = Routes.map((route, index) => {
    let routeComponent = null;

    if (typeof route.children !== "undefined") {
      const childrens = route.children;
      const childrenComponent = childrens.map((route, index) => (
        <AppComponent
          key={index}
          path={route.path}
          component={route.component}
        />
      ));

      routeComponent = (
        <AppComponent
          path={route.path}
          key={index}
          component={route.component}
        >
          {childrenComponent}
        </AppComponent>
      );
    } else {
      routeComponent = (
        <AppComponent
          key={index}
          path={route.path}
          component={route.component}
        />
      );
    }
    return routeComponent;
  });
  return (
    <Router basepath={basePath} location={location}>
      {RouteList}
    </Router>
  );
}

export default RouteComponent;
